/**
 * @upweo/i18n — one catalogue, six languages, shared by every surface.
 *
 * The admin dashboard, the partner portal, the storefront AND the API's email
 * templates all translate from this package. That is the point: an order
 * confirmation that says "Total" while the shop that produced it says
 * "Gesamt" is the kind of seam customers notice, and it happens whenever the
 * server and the client keep separate copies of the same words.
 *
 * The package is framework-free — no React, no i18next. React bindings live in
 * the apps, so the API can render a German email without pulling a UI library
 * into a Node process.
 */
import { ar } from './locales/ar.js';
import { de } from './locales/de.js';
import { en } from './locales/en.js';
import { es } from './locales/es.js';
import { fr } from './locales/fr.js';
import { hi } from './locales/hi.js';
import { DEFAULT_LOCALE } from './locales.js';
import { createTranslator } from './translate.js';
export const CATALOGUES = { en, es, fr, de, hi, ar };
/** A translator for one locale. Cheap to call; the Intl objects inside are cached. */
export const getTranslator = (locale = DEFAULT_LOCALE) => createTranslator(CATALOGUES, locale);
export { DEFAULT_LOCALE, LOCALES, LOCALE_CODES, isLocale, isRtl, localeMeta, negotiateLocale, } from './locales.js';
export { createTranslator } from './translate.js';
export { formatDate, formatDateTime, formatMoney, formatNumber, formatPercent, formatRelativeTime, } from './format.js';
//# sourceMappingURL=index.js.map